module.exports = __webpack_public_path__ + "img/thumnail14.79192f71.jpg";